import { Typography, Row, Col }  from 'antd'
import Breakpoint from '../../enums/breakpoint.enum.js'
import useWidth from '../../hooks/useWidth.hook.js'

const { Text, Paragraph } = Typography

export const MetforminConfirm = ({ flow }) => {
  const width = useWidth()

  const instructions = [{
    sections: [
      {
      title: 'Prescription Approval',
      description: <>An Instalab physician will review your health information as required by law. Once your prescription is approved (usually within 24 hours), we'll email you tracking information for your medication.</>
    }, 
  ]},
  
  {
    sections: [  {
      title: 'Begin Your Treatment',
      description: <>Start by taking 1 tablet by mouth once a day, with or without food. Pick a time that’s easy to remember; consistency is key to seeing results.</>
    }]
  }, 
  {
    sections: [{
      title: 'Track Your Progress',
      description: <>You can expect to see a reduction in your HOMA-IR and other markers of insulin resistance within about 4 weeks. We recommend testing your levels after 6-8 weeks of starting to make sure the medication is working for you.</>
    },
    {
        title: 'Test with Instalab\'s Insulin Resistance Panel',
        description: <>We recommend testing with Instalab's <a href={`/test/insulin-resistance-panel`} target="_blank" rel="noopener noreferrer">Insulin Resistance Panel</a> as this covers the key markers for tracking your medication's effectiveness.</>
    }
    ]
  },].filter(Boolean)

  return (
    <div className="prescription-approval">

      <div style={{fontWeight:600, marginBottom:10}}>Next steps:</div> 
      {instructions?.length > 0 && (
        <div className="instruction-list">
          {instructions.map(({ sections }, instructionIndex) => (
            <div 
              key={`instruction-${instructionIndex}`} 
              className="instruction-item"
            >
              <Row>
                <Col
                  style={{
                    width: width > Breakpoint.SM ? 80 : '100%',
                    marginBottom: width > Breakpoint.SM ? 0 : 10
                  }}
                >
                  <Text className="instruction-index">
                    Step {instructionIndex+1}
                  </Text>
                </Col>

                <Col
                  style={{
                    width: width > Breakpoint.SM ? 'calc(100% - 80px)' : '100%'
                  }}
                >
                  {sections.map(({ title, description }, sectionIndex) => (
                    <div 
                      key={`section-${instructionIndex}-${sectionIndex}`} 
                      className="section-item"
                    >
                      <Text className="section-title">
                        {title}
                      </Text>
                      <Paragraph className="section-description">
                        {description}
                      </Paragraph>
                    </div>
                  ))}
                  </Col>
              </Row>
            </div>
          ))}
        </div>
      )}


    </div>
  )
}

